import CommercialNetworkError from "./commercialNetworkError";
import { get, post, put, del } from "../http";
import { StatusCodes } from "http-status-codes";

const headers = {
  "Content-Type": "application/json",
};

const basePath = "/commercial/api";

const timeout = 15 * 1000;

const redirectToLogin = (): void => {
  window.location.replace("/login");
  sessionStorage.clear();
};

const handleError = async (response: Response): Promise<void> => {
  const { status } = response;
  if (status === StatusCodes.FORBIDDEN) {
    redirectToLogin();
    return;
  }

  if (response.headers.get("content-type") === "application/json") {
    const businessExceptionData = await response.json();
    throw new CommercialNetworkError(
      "Commercial network error occurred",
      status,
      businessExceptionData.code,
      businessExceptionData.id,
    );
  }

  await Promise.reject(response);
};

const processResponse = (response: Response, expectJSON = true) => {
  if (response.ok) {
    if (expectJSON) {
      return response.json();
    } else {
      return response.text();
    }
  }

  return handleError(response);
};

export const getCommercial = <T>(
  path: string,
  urlParameters?: Record<string, string>,
  expectsJSON?: boolean,
): Promise<T> => {
  return get(
    basePath + path,
    urlParameters,
    {
      headers,
    },
    timeout,
  )
    .then((response) => processResponse(response, expectsJSON))
    .catch((error) => {
      throw error;
    });
};

export const deleteCommercial = (path: string): Promise<void> => {
  return del(basePath + path, {}, {}, timeout)
    .then((response) => processResponse(response, false))
    .catch((error) => {
      throw error;
    });
};

export const postCommercial = <T>(
  path: string,
  requestBody?: unknown,
): Promise<T> => {
  return post(
    basePath + path,
    JSON.stringify(requestBody),
    {
      headers,
    },
    timeout,
  )
    .then((response) => processResponse(response, false))
    .catch((error) => {
      throw error;
    });
};

export const putCommercial = (
  path: string,
  requestBody: unknown,
): Promise<void> => {
  return put(
    basePath + path,
    JSON.stringify(requestBody),
    {
      headers,
    },
    timeout,
  )
    .then((response) => processResponse(response, false))
    .catch((error) => {
      throw error;
    });
};

export const postFileCommercial = <T>(
  path: string,
  file: FormData,
  providedTimeoutSeconds?: number,
): Promise<T> => {
  const timeoutInMilliseconds = providedTimeoutSeconds
    ? providedTimeoutSeconds * 1000
    : timeout;

  return post(
    basePath + path,
    file,
    undefined,
    providedTimeoutSeconds ? timeoutInMilliseconds : timeout,
  )
    .then((response) => processResponse(response))
    .catch((error) => {
      throw error;
    });
};
